import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { API_URL } from "./api";

import LoginPage from "./components/login/LoginPage";
import RegisterPage from "./components/register/register";
import UserPage from "./components/user-area/user-area";
import AnimationPage from "./components/Animation/AnimationPage.js";
import ErrorPage from "./components/error/ErrorPage";
import Offline from "./components/offline/offline";

function App() {
	const cookies = new Cookies();
	const [sessionToken] = useState(cookies.get("sessionToken"));
	const [page, setPage] = useState(0);
	const [ChildData, setChildData] = useState({});
	const [error, SetError] = useState(false);

	useEffect(() => {
		window.addEventListener("offline", function (event) {
			setPage(5);
		});

		window.addEventListener("online", function (event) {
			window.location.reload();
		});

		if (!navigator.onLine) {
			setPage(5);
		} else if (sessionToken === undefined) {
			setPage(3);
		} else if (sessionToken === "logout") {
			setPage(2);
		} else {
			fetch(
				`${API_URL}/api/VerifyToken?token=${encodeURIComponent(
					sessionToken
				)}`
			)
				.then((response) => {
					if (response.ok) {
						return response.json();
					} else {
						setPage(6);
						SetError("Server ni dosegljiv: " + response.error);
					}
				})

				.then((data) => {
					if (data.status === true) {
						setChildData(data.user_data);
						setPage(1);
					} else {
						setPage(2);
					}
				})
				.catch((error) => {
					SetError("Napaka: " + error.message);
					setPage(6);
				});
		}
	}, [sessionToken]);

	return (
		<div>
			{page === 0 && <AnimationPage />}
			{page === 1 && <UserPage data={ChildData} />}
			{page === 2 && (
				<div>
					<LoginPage />
				</div>
			)}
			{page === 3 && (
				<div>
					<RegisterPage />
				</div>
			)}
			{page === 5 && <Offline />}
			{page === 6 && <ErrorPage error={error} />}
		</div>
	);
}

export default App;
